import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {User} from "../types.ts";
import {useUser} from "../hooks/useUser.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        record,
        createRecord,
    } = useUser();

    return (
        <FormDrawer
            record={record ?? {} as User}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
